import Header from './components/Header';
import HeroSection from './components/HeroSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <MediaSection />
        <RankingSection />
        <AboutSection />
        <FAQSection />
        <FeaturesSection />
        <CommentsSection />
        <UpdatesSection />
        <CarouselSection />
        <ContactSection />
        <TopicsSection />
        <IndexSection />
        <AppSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}